export enum DataLayersActions {
  UPDATE_DATA_LAYERS = 'UPDATE_DATA_LAYERS',
  RESET_DATA_LAYERS = 'RESET_DATA_LAYERS',
  SET_POLYGONS = 'SET_POLYGONS',
  REMOVE_POLYGONS = 'REMOVE_POLYGONS',
  ADD_POLYGON = 'ADD_POLYGON',
  OPEN_CLOSE_USER_OPTIONS = 'OPEN_CLOSE_USER_OPTIONS',
  SET_IS_PRESSED = 'SET_IS_PRESSED',
  UPDATE_OPTIONS = 'UPDATE_OPTIONS',
  UPDATE_OPTION_MARKERS = 'UPDATE_OPTION_MARKERS',
}

type updateDataLayersParams = {
  name: string;
  value: boolean;
};

export const updateDataLayers = (payload: updateDataLayersParams) => ({
  type: DataLayersActions.UPDATE_DATA_LAYERS,
  payload,
});

export const resetDataLayers = () => ({
  type: DataLayersActions.RESET_DATA_LAYERS,
});

type setOrAddPolygonsParams = {
  name: string;
  value: any;
};
export const setPolygons = (payload: setOrAddPolygonsParams) => ({
  type: DataLayersActions.SET_POLYGONS,
  payload,
});

export const removePolygons = (payload: string) => ({
  type: DataLayersActions.REMOVE_POLYGONS,
  payload,
});

export const addPolygon = (payload: setOrAddPolygonsParams) => ({
  type: DataLayersActions.ADD_POLYGON,
  payload,
});

export const openCloseUserOptions = () => ({
  type: DataLayersActions.OPEN_CLOSE_USER_OPTIONS,
});

export const setIsPressed = (payload: boolean) => ({
  type: DataLayersActions.SET_IS_PRESSED,
  payload,
});

type updateOptionsParams = {
  name: string;
  options: Record<string, any>[];
};

export const updateOptions = (payload: updateOptionsParams) => ({
  type: DataLayersActions.UPDATE_OPTIONS,
  payload,
});

type updateOptionMarkersParams = {
  name: string;
  markers: google.maps.Marker[];
};

export const updateOptionMarkers = (payload: updateOptionMarkersParams) => ({
  type: DataLayersActions.UPDATE_OPTION_MARKERS,
  payload,
});
